import React, { useState, useEffect } from 'react';
import {
    Button, Typography, Grid, Card, CardContent, CardActionArea, Box,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { tipoPersonaService } from '../../services/tipoPersonaService';
import { useTheme } from '@mui/material/styles';
import casa from '../../img/casa.png';
import empresa from '../../img/empresa.png';


const Paso1TipoPersona = ({ onNext, initialData }) => {
    const [tiposPersona, setTiposPersona] = useState([]);
    const [selected, setSelected] = useState(initialData.tipoPersona || null);
    const [loading, setLoading] = useState(true);
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();

    useEffect(() => {
        const cargarTiposPersona = async () => {
            try {
                const response = await tipoPersonaService.obtenerTodos();
                setTiposPersona(response.data);
            } catch (error) {
                enqueueSnackbar('Error al cargar tipos de persona', { variant: 'error' });
            } finally {
                setLoading(false);
            }
        };

        cargarTiposPersona();
    }, [enqueueSnackbar]);

    const handleSelect = (tipo) => {
        setSelected(tipo);
    };

    const handleContinue = () => {
        if (!selected) {
            enqueueSnackbar('Debes seleccionar un tipo de persona', { variant: 'error' });
            return;
        }
        onNext({ tipoPersona: selected });
    };

    // Imágenes de ejemplo - reemplazar con tus imágenes reales
    const getImageForType = (tipoId) => {
        const images = {
            1: casa,
            2: empresa,
        };
        return images[tipoId] || 'https://via.placeholder.com/80/757575/ffffff?text=Imagen';
    };

    return (
        <div>
            <Typography variant="h5" gutterBottom>
                Selecciona donde planeas instalar tu proyecto
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
                Esta información nos ayuda a personalizar tu cotización
            </Typography>

            {loading ? (
                <Typography>Cargando opciones...</Typography>
            ) : (
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '16px',
                    justifyContent: 'center'
                }}>
                    {tiposPersona.map((tipo) => (
                        <Card
                            key={tipo.Id}
                            sx={{
                                width: '35%', // Ocupa casi la mitad del contenedor
                                minWidth: '250px', // Ancho mínimo
                                border: selected?.Id === tipo.Id ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                p: 2
                            }}
                        >
                            <CardActionArea
                                onClick={() => handleSelect(tipo)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    width: '100%'
                                }}
                            >
                                <Box
                                    component="img"
                                    src={getImageForType(tipo.Id)}
                                    alt={tipo.Nombre}
                                    sx={{
                                        width: '60px',
                                        height: '60px',
                                        objectFit: 'contain',
                                        mb: 1
                                    }}
                                />
                                <CardContent sx={{ p: 0, textAlign: 'center' }}>
                                    <Typography variant="h6" sx={{ fontSize: '1rem', mb: 0.5 }}>
                                        {tipo.Nombre}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                        {tipo.Descripcion}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button
                    variant="contained"
                    onClick={handleContinue}
                    disabled={!selected}
                    sx={{
                        fontFamily: '"Montserrat", sans-serif',
                        fontWeight: 500
                    }}
                >
                    Continuar
                </Button>
            </Box>
        </div>
    );
};

export default Paso1TipoPersona;